export const isFullWidthAppearance = appearance => appearance === 'full-width';
export const isFullPageAppearance = appearance => appearance === 'full-page';
export const isFullWidthOrFullPageAppearance = appearance => isFullPageAppearance(appearance) || isFullWidthAppearance(appearance);